module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar docs-navbar is-spaced has-shadow",
    class: {
      'is-primary is-transparent': _vm.light
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/",
      "title": "Buefy: lightweight UI components for Vue.js based on Bulma",
      "active-class": ""
    }
  }, [(_vm.light) ? _c('img', {
    attrs: {
      "src": require("../assets/buefy-light.png"),
      "alt": "Buefy"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/buefy.png"),
      "alt": "Buefy"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    class: {
      'has-text-dark': !_vm.light
    },
    attrs: {
      "href": "https://github.com/buefy/buefy",
      "target": "_blank",
      "title": "Github"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "github-circle"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    class: {
      'has-text-discord': !_vm.light
    },
    attrs: {
      "href": "https://discordapp.com/invite/ZkdFJMr",
      "target": "_blank",
      "title": "Discord"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "discord"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.isMenuActive
    },
    on: {
      "click": function($event) {
        _vm.isMenuActive = !_vm.isMenuActive
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("\n                        Home\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("\n                        Documentation\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/extensions"
    }
  }, [_vm._v("\n                        Extensions\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/expo"
    }
  }, [_vm._v("\n                        Expo\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('div', {
    staticClass: "navbar-link"
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-boxed"
  }, [_c('strong', {
    staticClass: "navbar-item is-version"
  }, [_c('span', {
    staticClass: "has-text-primary"
  }, [_vm._v("Buefy version")]), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('strong', {
    staticClass: "navbar-item is-version"
  }, [_c('span', {
    staticClass: "has-text-bulma"
  }, [_vm._v("Bulma version")]), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v(_vm._s(_vm.bulmaVersion))])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "https://github.com/buefy/buefy/releases",
      "target": "_blank"
    }
  }, [_vm._v("\n                                Changelogs\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    staticClass: "button is-outlined",
    class: _vm.light ? 'is-light' : 'is-twitter',
    on: {
      "click": _vm.tweet
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tweet")])], 1)])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bfd5e74"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/components/TheNavbar.vue
// module id = 912
// module chunks = 0 2 300